import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { Button, DateRangePicker } from "components";
import { localStorageHelper } from "utils";

import {
  IConsultDetails,
  IConsultQAItem,
} from "models/consultations/consultationDetails";
import { GetConsultationDetailsActionCreators } from "redux/rootActions";
import {
  selectIsLoadingConsultationDetails,
  selectConsultationDetailsErrorMessage,
  consultationDetailsDataResponse,
} from "redux/consultations/consultationDetails/consultationDetailsStates";

import {
  UserDetailTitle,
  ModalUserDetail,
  Information,
  InformationTitle,
  InformationContent,
  InformationContentLeft,
  InformationContentRight,
  InformationGroup,
  Questionaire,
  Question,
  QuestionName,
  QuestionAnswer,
  QuestionAnswer2,
  DiagnosisAnswer,
} from "./EducationConsultationList.style";
import { returnTest, returnTestComment } from "./EducationConsultationList";

type ConsultType = "patient" | "consultation";

interface IConsultationDetailsModalProps {
  type: ConsultType;
  isVisibleModal: boolean;
  setIsVisibleModal: (visible: boolean) => void;
  id: string;
}

const ConsultationDetailsModal = ({
  type,
  isVisibleModal,
  setIsVisibleModal,
  id,
}: IConsultationDetailsModalProps) => {
  const dispatch = useDispatch();
  const currentLanguage = localStorageHelper.getItem("i18nextLng");

  const isLoadingConsultDetails = useSelector(
    selectIsLoadingConsultationDetails
  );

  const consultDetailsError = useSelector(
    selectConsultationDetailsErrorMessage
  );

  const consultDetailsData = useSelector(consultationDetailsDataResponse);

  const [consultationDetails, setConsultationDetails] = useState<
    IConsultDetails | undefined
  >(undefined);

  const dateFormat = "YYYY-MM-DD";
  const freeComment = "口の中を切った";
  const checkConsultDetails =
    consultationDetails && Object.keys(consultationDetails).length > 0;

  const handleDate = (date: string) => {
    const currentTimeZone = localStorageHelper.getItem("currentTimeZone");
    const format =
      currentLanguage == "ja" ? "YYYY年MM月DD日 HH:mm" : "YYYY-MM-DD HH:mm";

    return moment(date).utc().add(9, "hours").format(format);
  };

  const returnDiagnosisTitle = (title: string, comment: string) => {
    if (!title || (title && !title.trim())) {
      if (comment && comment.trim()) {
        return "医師がフリーコメントで回答";
      } else {
        return "-";
      }
    } else if (title?.toLowerCase() === "comment" && !comment) {
      return "-";
    } else if (title?.toLowerCase() === "comment" && comment) {
      return "医師がフリーコメントで回答";
    } else if (
      title?.toLowerCase().startsWith("comment,") ||
      title?.toLowerCase().startsWith("comment ,")
    ) {
      return title.split(",")[1].trim();
    } else if (
      title?.toLowerCase().endsWith(",comment") ||
      title?.toLowerCase().endsWith(", comment")
    ) {
      return title.split(",")[0].trim();
    } else if (title.trim()) {
      return title;
    }
  };

  const returnStatus = (status: number) => {
    switch (status) {
      case 0:
        return {
          name: "キャンセル",
          background: "#CCCCCC",
        };
      case 1:
        return {
          name: "相談中",
          background: "#EBC300",
        };
      case 2:
        return {
          name: "相談済",
          background: "#2F8CAE",
        };
      default:
        return;
    }
  };

  useEffect(() => {
    if (id && isVisibleModal && type === "consultation") {
      dispatch(
        GetConsultationDetailsActionCreators.getConsultationDetailsAction({
          id: id,
        })
      );
    }
  }, [id, isVisibleModal, type]);

  useEffect(() => {
    if (
      consultDetailsData?.result &&
      Object.keys(consultDetailsData.result).length > 0 &&
      !isLoadingConsultDetails
    ) {
      setConsultationDetails(consultDetailsData.result);
    } else {
      setConsultationDetails(undefined);
    }
  }, [consultDetailsData, isLoadingConsultDetails]);

  useEffect(() => {
    if (consultDetailsError) {
      setConsultationDetails(undefined);
      dispatch(GetConsultationDetailsActionCreators.handleResetDataAction());
    }
  }, [consultDetailsError]);

  const genderGroup: any = {
    0: "男性",
    1: "女性",
    2: "回答なし",
  };

  return (
    <ModalUserDetail
      type="form"
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <UserDetailTitle width="300px">
            {genderGroup[consultationDetails?.patient?.gender as any]}/
            {consultationDetails?.patient?.age ?? "-"}歳
          </UserDetailTitle>
        </div>
      }
      visible={isVisibleModal}
      onCancel={() => {
        setIsVisibleModal(false);
        setConsultationDetails(undefined);
      }}
    // onOk={handleSubmit(onSubmit)}
    >
      {checkConsultDetails && (
        <Information>
          <InformationTitle>
            {/* <div className="dot"></div> */}
            <div>
              {handleDate(consultationDetails?.consultation_created_at)}
            </div>
            {/* <Button
              // onClick={handleOk}
              background={
                returnStatus(consultationDetails.status)
                  ?.background
              }
              color="#fff"
              name={
                returnStatus(consultationDetails.status)?.name
              }
              border="none"
              bdr="12px"
              fontSize={14}
              fontWeight={500}
              padding="4px 6px 2px"
            /> */}
          </InformationTitle>
          <InformationContent>
            <InformationContentLeft>
              <InformationGroup>
                <div>主訴</div>
                <div>
                  {consultationDetails?.disease_name ? (
                    consultationDetails?.disease_name
                  ) : (
                    <span>-</span>
                  )}
                </div>
              </InformationGroup>
              <InformationGroup>
                <div>疑い病名</div>
                <DiagnosisAnswer>
                  {returnDiagnosisTitle(
                    consultationDetails?.diagnosis_title,
                    consultationDetails?.diagnosis_comment
                  ) === "-" ||
                  !returnDiagnosisTitle(
                    consultationDetails?.diagnosis_title,
                    consultationDetails?.diagnosis_comment
                  ) ? (
                    <span>-</span>
                  ) : (
                    returnDiagnosisTitle(
                      consultationDetails?.diagnosis_title,
                      consultationDetails?.diagnosis_comment
                    )
                  )}
                  {/* {consultationDetails?.diagnosis_title ? (
                    consultationDetails.diagnosis_title
                  ) : consultationDetails?.diagnosis_comment ? (
                    "医師がフリーコメントで回答"
                  ) : (
                    <></>
                  )}
                  {consultationDetails?.diagnosis_comment ? (
                    <span>{consultationDetails.diagnosis_comment}</span>
                  ) : (
                    <></>
                  )} */}
                </DiagnosisAnswer>
              </InformationGroup>
              <InformationGroup>
                <div>おすすめの診療科</div>
                <div>
                  {consultationDetails.hospital_names ? (
                    consultationDetails.hospital_names
                  ) : (
                    <span>-</span>
                  )}
                </div>
              </InformationGroup>
              <InformationGroup>
                <div>緊急性</div>
                <div>
                  {consultationDetails?.medical_instruction_title &&
                    returnTestComment(
                      consultationDetails.medical_instruction_title
                    ) ? (
                    consultationDetails.medical_instruction_title
                  ) : consultationDetails?.doctor_response_created_at ? (
                    "医師がフリーコメントで回答"
                  ) : (
                    <span>-</span>
                  )}
                </div>
              </InformationGroup>
              <InformationGroup>
                <div>おすすめの市販薬</div>
                <DiagnosisAnswer>
                  {consultationDetails?.medicines_name ? (
                    consultationDetails.medicines_name
                  ) : consultationDetails?.medicine_comment ? (
                    "医師がフリーコメントで回答"
                  ) : (
                    <span>-</span>
                  )}
                  {/* {consultationDetails?.medicine_comment ? (
                    <span>{consultationDetails.medicine_comment}</span>
                  ) : (
                    <></>
                  )} */}
                </DiagnosisAnswer>
              </InformationGroup>
              {/* <InformationGroup>
                <div>回答した医師</div>
                <div>
                  {consultationDetails.doctor_name ? (
                    consultationDetails.doctor_name
                  ) : (
                    <span>-</span>
                  )}
                </div>
              </InformationGroup> */}
            </InformationContentLeft>
            <InformationContentRight>
              <div>問診内容</div>
              <Questionaire>
                {consultationDetails.consultations_question_answers &&
                  consultationDetails.consultations_question_answers.length &&
                  consultationDetails.consultations_question_answers.map(
                    (question: IConsultQAItem) => (
                      <Question key={question.id}>
                        <QuestionName>{question.question_text}</QuestionName>
                        {question.answer_text ? (
                          <QuestionAnswer>
                            {consultationDetails?.disease_name !== "フリー相談"
                              ? question.answer_text
                              : "患者がフリーコメントで相談"}
                          </QuestionAnswer>
                        ) : (
                          <QuestionAnswer>
                            {question?.comment
                              ? "患者がフリーコメントで相談"
                              : "-"}
                          </QuestionAnswer>
                        )}
                        {/* {question.comment && returnTest(question.comment) && (
                          <QuestionAnswer2>
                            フリーコメント：<span>{question.comment}</span>
                          </QuestionAnswer2>
                        )} */}
                      </Question>
                    )
                  )}
              </Questionaire>
            </InformationContentRight>
          </InformationContent>
        </Information>
      )}
      {!checkConsultDetails && (
        <div style={{ fontSize: 16, lineHeight: "16px", fontWeight: 400 }}>
          データがありません
        </div>
      )}
    </ModalUserDetail>
  );
};

export default ConsultationDetailsModal;
